import { fetcher, IFetchResponseBase } from "./api";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function del<T>(url: string, data?: object): Promise<IFetchResponseBase> {
  return await fetcher({
    url: url,
    method: "DELETE",
    ...(data && { body: data }),
  });
}
